import "@formatjs/intl-displaynames/polyfill";
import "@formatjs/intl-displaynames/locale-data/en";
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/css/style.css";
import registerServiceWorker from "./registerServiceWorker";
import PowformApp from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<PowformApp />);
registerServiceWorker();
